module.exports = __webpack_public_path__ + "img/Extra-7-548x298.b57c418f.jpg";